import React from "react";
// used for making the prop types of this component
// import PropTypes from "prop-types";

class TableBooleanInput extends React.Component {
    state = {

        checked: true
    }
    componentWillMount() {
    }

  

    render() {

        return (
            <div className='mt-2 w-100 flexcc'>

                {this.props.data && (

                    <>
                     <img width={17} src="/images/check2.png"/>
                    </>
                )}
                {/* <p className="fs-18 text-center">{this.props.data? this.props.header.information.value:''}</p> */}
            </div>
        );
    }
}

export default TableBooleanInput;
